<template>
  <div class="center detail" v-bind:class="{'desktop-listing':!isMobile, 'mobile-listing':isMobile}">
    <v-container fluid grid-list-md>
      <v-flex v-bind="{ [`${flex}`]: false }">
        <v-layout column>
          <v-card flat>
            <v-card-title><h4>{{ property.title }}</h4></v-card-title>
            <v-card-title v-if="property.sold"><span class="label">售出日期:</span><span class="value">{{ property.soldDate }}</span></v-card-title>
            <v-card-title v-if="property.sold"><span class="label">售价:</span><span class="value">{{ formatPrice(property.soldPrice) }}</span></v-card-title>
            <v-card-title v-else><span class="label">售价:</span><span class="value">{{ formatPrice(property.price) }}</span>
              <v-btn small light flat @click="calculate(property.price)"><v-icon small color="grey darken-1">fas fa-calculator</v-icon>&nbsp;<span class="link">按揭计算器</span></v-btn>
            </v-card-title>
            <v-card-title><span class="label">居住面积:</span><span class="value">{{ property.livingArea }} 平方英尺</span></v-card-title>
            <v-card-title><span class="label">地皮面积:</span><span class="value">{{ property.lotSize?(property.lotSize +' 平方英尺'):(property.lotSizeAcre?(property.lotSizeAcre+' 平方英亩'):'') }}</span></v-card-title>
            <v-card-title><span class="label">卧室:</span><span class="value">{{ property.bedroom }}</span> </v-card-title>
            <v-card-title><span class="label">卫生间:</span><span class="value">{{ property.bathroom }}</span> </v-card-title>
            <v-card-title><span class="label">建筑年份:</span><span class="value">{{ property.yearBuild }}</span> </v-card-title>
            <v-data-iterator v-if="property.picsWithTitle" :items="property.picsWithTitle" hideActions content-tag="v-layout" row wrap>
              <v-flex slot="item" slot-scope="props">
                <div class="img-container">
                  <div class="pic-title-bg"><div class="pic-title">{{ props.item.title }}</div></div>
                  <v-img :lazy-src="property.thumb?(imgPath+property.id+'/thumbs/'+props.item.pic):''"  :src="imgPath+property.id+'/'+props.item.pic">
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                </div>
              </v-flex>
            </v-data-iterator>
            <v-data-iterator v-else :items="property.pics" hideActions content-tag="v-layout" row wrap>
              <v-flex slot="item" slot-scope="props">
                <div class="img-container">
                  <v-img :lazy-src="property.thumb?(imgPath+property.id+'/thumbs/'+props.item):''"  :src="imgPath+property.id+'/'+props.item">
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                </div>
              </v-flex>
            </v-data-iterator>
            <v-card-text class="back-btn">
              <v-btn small light round @click="back">
                <v-icon small color="pink">fas fa-chevron-left</v-icon>&nbsp;返回
              </v-btn>
            </v-card-text>
            <div class="bottom-space"></div>
          </v-card>
        </v-layout>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import {Utils} from '../../utils'

    export default {
        name: "detail",
      data(){
        return {
          imgPath: 'http://www.juliazhao.com/realestate/properties/'
        }
      },
      computed: {
        ...mapState({
          isMobile: state => state.homeStore.isMobile,
          property: state => state.homeStore.currentProperty
        }),
        flex: {
          get(){
            if( this.isMobile ) return 'xs12'
            return 'xs6'
          },
          set(val){

          }
        }
      },
      methods: {
        ...mapMutations(['setCalculatePrice']),
        formatPrice: function (price) {
          return Utils.getPriceTxt(price, true)
        },
        back(){
          this.$router.go(-1)
        },
        calculate(price){
          this.setCalculatePrice(price)
          this.$router.push('/zh/calculator')
        }
      }
    }
</script>

<style scoped>
  @import "../detail.css";
</style>
